import Head from 'next/head';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { useRecoilState } from 'recoil';

import { tokenUpdate } from '../../atoms/authModalControl';
import CartPage from '../../components/CartPage';
import { pageTitle } from '../../components/shared/basic/customHead';
import CustomLoader from '../../components/shared/Loading';
import { mergeAllCarts } from '../../services/Cart';
import { getUserProfile } from '../../services/user';

const Cart = () => {
  const [loading, setLoading] = useState(true);
  const [isTokenChanged, setIsTokenChanged] = useRecoilState(tokenUpdate);
  const router = useRouter();

  const checkAuthentication = async () => {
    await getUserProfile();
  };

  const handleMergeAllCarts = async () => {
    try {
      await mergeAllCarts();
    } catch (error: any) {
      // notify(formateErrorObject(error));
    }
  };

  const fetchData = async () => {
    try {
      await checkAuthentication();
      await handleMergeAllCarts();
      setLoading(false);
    } catch {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (router.isReady && !isTokenChanged) {
      if (router.asPath?.toString() === '/cart/') {
        fetchData();
      } else {
        setLoading(false);
      }
    }
    if (isTokenChanged) {
      setIsTokenChanged(false);
    }
  }, [router.isReady, router.asPath, isTokenChanged]);

  return (
    <>
      <Head>
        <title>{pageTitle('Cart')}</title>
      </Head>
      {loading ? <CustomLoader /> : <CartPage />}
    </>
  );
};

export default Cart;
